
const API_URL = process.env.REACT_APP_API_URL + "settings/"

export const getAllSettingsApi = async()=>{
    console.log("📡 GET request to:", API_URL);
    let data = {}
    let response = await fetch(API_URL, {
      method: 'GET',
    })
  
    console.log("📡 GET response status:", response.status);
    
    if(response.status === 200){
      data= await response.json()
      console.log("📋 GET response data:", data);
      console.log("  holidayPricingDays in GET response:", data.holidayPricingDays);
    }
  
    return {
      data: data,
      status: response.status
    }
  } 

  export const UpdateSettingsApi = async (requestData) => {
    let data=null
    const token=localStorage.getItem("token")
    
    console.log("🔄 PUT request - Sending to API:", requestData);
    console.log("  PUT request - holidayPricingDays being sent:", requestData.holidayPricingDays);
    console.log("🔑 Token:", token ? "Token exists" : "No token");
    console.log("🌐 API URL:", API_URL);
    
    const requestBody = JSON.stringify(requestData);
    console.log("📤 Request body:", requestBody);
        
    const response = await fetch(API_URL , {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: requestBody
    });
  
    console.log("📡 PUT response status:", response.status);
    console.log("📡 PUT response headers:", response.headers);
        
    if (response.ok) {
      data = await response.json();
      console.log("✅ PUT response data:", data);
      console.log("  PUT response - holidayPricingDays received:", data.holidayPricingDays);
    } else {
      const errorText = await response.text();
      console.error("❌ PUT API Error:", errorText);
      console.error("❌ PUT Error status:", response.status);
      throw new Error(`API Error: ${response.status} - ${errorText}`);
    }
  
    return {
      data: data,
      status: response.status
    };
  };
  